export default "__VITE_ASSET__ClawS4EC__"